import React from 'react';
import EventMiraeAssetDetailPage from '../../pages/EventMiraeassetDetailPage';
import * as IMAGE from '../../lib/image/event/EventMiraeassetImages';

export const TITLE_MIRAEASSET = '미래에셋증권 x 베이비페이스';
export const ID_MIRAEASSET = 'miraeasset';
export const PERIOD_MIRAEASSET = {
  startDate: '2024-04-15T00:00:00',
  endDate: '2024-06-30T23:59:59',
};

export const EVENT_HOME_BANNER_MIRAEASSET = {
  id: ID_MIRAEASSET,
  period: PERIOD_MIRAEASSET,
  image: IMAGE.HOME_BANNER_MIRAEASSET,
};

export const EVENT_BANNER_MIRAEASSET = {
  id: ID_MIRAEASSET,
  period: PERIOD_MIRAEASSET,
  image: IMAGE.EVENT_BANNER_MIRAEASSET,
};

export const EVENT_COMPONENT_MIRAEASSET = {
  id: ID_MIRAEASSET,
  component: (
    <EventMiraeAssetDetailPage />
  ),
};
